/**
 * Каталог скинов Рублокса — наши собственные стилизованные персонажи.
 *
 * До 2026-06-11: скины из Roblox (заблокирован в РФ → нельзя использовать).
 * С 2026-06-11: 80 персонажей из Mixamo (Adobe-лицензия,
 * можно для коммерческого использования).
 *
 * GLB-файлы лежат в public/character-assets/skins/.
 * Все ~3 МБ после конвертации FBX → GLB → webp.
 *
 * 2026-06-14: убраны 2 дубля (skin_maria-wprop, skin_erika-archer-bow),
 * номерные ch01..ch48 переименованы по их внешнему виду, расставлены
 * индивидуальные цены 20-300 алмазов (шаг 10). skin_y-bot и skin_x-bot —
 * бесплатные дефолты по гендеру (выдаются при регистрации).
 */

/** Дефолтный скин по умолчанию (если пол неизвестен) — Игрек-Бот. */
export const DEFAULT_FREE_SKIN = "skin_y-bot";

/**
 * Возвращает дефолтный скин для пользователя в зависимости от пола.
 * - 'male' → skin_x-bot (Икс-Бот)
 * - 'female' / null / undefined → skin_y-bot (Игрек-Бот)
 */
export function defaultSkinForGender(gender) {
  return gender === "male" ? "skin_x-bot" : "skin_y-bot";
}

/** Дефолтная цена (на случай если не указана в записи). */
export const SKIN_PRICE = 100;

/**
 * Полный каталог. У каждого скина:
 *   folder — id (совпадает с именем GLB/PNG-файла)
 *   name   — человечьее имя
 *   price  — стоимость в алмазах. 0 = бесплатно (дефолтные ботs)
 *   avatar, glb — пути к ресурсам
 */
const _entries = [
  // ── Бесплатные дефолты (выдаются по гендеру при регистрации) ──
  { folder: "skin_y-bot", name: "Игрек-Бот", price: 0 },
  { folder: "skin_x-bot", name: "Икс-Бот", price: 0 },

  // ── Mixamo с собственными именами ──
  { folder: "skin_akai", name: "Акай", price: 220 },
  { folder: "skin_arissa", name: "Арисса", price: 50 },
  { folder: "skin_white-clown", name: "Белый клоун", price: 20 },
  { folder: "skin_big-vegas", name: "Биг-Вегас", price: 250 },
  { folder: "skin_vampire", name: "Вампир", price: 100 },
  { folder: "skin_war-zombie", name: "Военный зомби", price: 90 },
  { folder: "skin_warrok", name: "Воррок", price: 90 },
  { folder: "skin_survivor", name: "Выживший", price: 60 },
  { folder: "skin_ganfaul", name: "Ганфол", price: 250 },
  { folder: "skin_heraklios", name: "Гераклиос", price: 50 },
  { folder: "skin_demon", name: "Демон", price: 230 },
  { folder: "skin_eve", name: "Ева", price: 250 },
  { folder: "skin_prisoner", name: "Заключённый", price: 300 },
  { folder: "skin_kachujin", name: "Качуджин", price: 190 },
  { folder: "skin_kaya", name: "Кая", price: 40 },
  { folder: "skin_claire", name: "Клер", price: 200 },
  { folder: "skin_peasant-man", name: "Крестьянин", price: 150 },
  { folder: "skin_peasant-girl", name: "Крестьянка", price: 30 },
  { folder: "skin_lola", name: "Лола", price: 20 },
  { folder: "skin_passive-marker-man", name: "Манекен", price: 40 },
  { folder: "skin_maria", name: "Мария", price: 80 },
  { folder: "skin_medea", name: "Медея", price: 90 },
  { folder: "skin_maw", name: "Мо", price: 180 },
  { folder: "skin_mutant", name: "Мутант", price: 210 },
  { folder: "skin_nightshade", name: "Найтшейд", price: 20 },
  { folder: "skin_paladin", name: "Паладин", price: 190 },

  // ── Номерные ch01..ch48 — переименованы по внешнему виду ──
  { folder: "skin_ch01", name: "Стиляга", price: 80 },                  // мужчина в белой поло и джинсах
  { folder: "skin_ch02", name: "Солнышко", price: 240 },                // девушка в жёлтом свитере
  { folder: "skin_ch03", name: "Диско-королева", price: 220 },          // тёмнокожая с пучками
  { folder: "skin_ch04", name: "Ящер-страж", price: 240 },              // зеленокожий монстр-воин
  { folder: "skin_ch07", name: "Деловая леди", price: 190 },            // в синем костюме
  { folder: "skin_ch08", name: "Атлет", price: 150 },                   // в белом спорткостюме
  { folder: "skin_ch09", name: "Капитан Кепка", price: 90 },            // мальчик в красной кепке
  { folder: "skin_ch10", name: "Голодный мертвец", price: 160 },        // зомби
  { folder: "skin_ch11", name: "Биозащитник", price: 200 },             // в белом скафандре
  { folder: "skin_ch13", name: "Шеф Мишлен", price: 100 },              // официантка/шеф
  { folder: "skin_ch14", name: "Лисёнок", price: 270 },                 // мультяшный лис
  { folder: "skin_ch15", name: "Камуфляжник", price: 290 },             // солдат в камуфляже
  { folder: "skin_ch16", name: "Доктор Айболит", price: 20 },           // хирург
  { folder: "skin_ch17", name: "Прораб", price: 260 },                  // строитель в каске
  { folder: "skin_ch18", name: "Тайный агент", price: 270 },            // в чёрном и очках
  { folder: "skin_ch19", name: "Гоблинчик", price: 70 },                // синий эльф-ребёнок
  { folder: "skin_ch20", name: "Рейсер", price: 240 },                  // гонщик
  { folder: "skin_ch21", name: "Кэжуал-Кейт", price: 150 },             // девушка в синей рубашке
  { folder: "skin_ch22", name: "Студентка", price: 120 },               // в белой футболке и джинсах
  { folder: "skin_ch23", name: "Кардиган-бой", price: 100 },            // парень в кардигане
  { folder: "skin_ch24", name: "Ниндзя теней", price: 60 },             // ниндзя
  { folder: "skin_ch29", name: "Скейтер-гёрл", price: 80 },             // киберспортсменка
  { folder: "skin_ch31", name: "Хипстер", price: 260 },                 // парень в чёрном свитере
  { folder: "skin_ch32", name: "Беглец", price: 120 },                  // заключённый
  { folder: "skin_ch33", name: "Мистер Бизнес", price: 50 },            // бизнесмен
  { folder: "skin_ch34", name: "Лесная фея", price: 40 },               // зелёная эльфийка
  { folder: "skin_ch35", name: "Чистильщик", price: 140 },              // спецназ с противогазом
  { folder: "skin_ch39", name: "Маг-старейшина", price: 50 },           // старый мудрец
  { folder: "skin_ch40", name: "Тёмная жрица", price: 130 },            // демоница в золотом
  { folder: "skin_ch42", name: "Уличный боец", price: 290 },            // парень в красной футболке
  { folder: "skin_ch43", name: "Эль Гордо", price: 130 },               // мексиканский рестлер
  { folder: "skin_ch44", name: "Чёрная пантера", price: 210 },          // человек-тень
  { folder: "skin_ch45", name: "Био-мутант", price: 100 },              // тёмный мутант
  { folder: "skin_ch46", name: "Мятная мечта", price: 270 },            // девочка-аниме с голубыми волосами
  { folder: "skin_ch47", name: "Алая кошка", price: 30 },               // женщина-кошка в красном
  { folder: "skin_ch48", name: "Звёздный лётчик", price: 250 },         // астронавт в белом

  // ── Остальные Mixamo ──
  { folder: "skin_knight", name: "Рыцарь", price: 160 },
  { folder: "skin_skeleton-zombie", name: "Скелет-зомби", price: 190 },
  { folder: "skin_swat", name: "Спецназ", price: 50 },
  { folder: "skin_sporty-granny", name: "Спортивная бабушка", price: 140 },
  { folder: "skin_castle-guard-1", name: "Стражник замка 1", price: 40 },
  { folder: "skin_castle-guard-2", name: "Стражник замка 2", price: 190 },
  { folder: "skin_ty", name: "Тай", price: 110 },
  { folder: "skin_pumpkinhulk", name: "Тыквенный Халк", price: 280 },
  { folder: "skin_uriel", name: "Уриил", price: 220 },
  { folder: "skin_aj", name: "Эй-Джей", price: 210 },
  { folder: "skin_exo-red", name: "Экзо-красный", price: 300 },
  { folder: "skin_exo-gray", name: "Экзо-серый", price: 290 },
  { folder: "skin_ely", name: "Эли", price: 130 },
  { folder: "skin_erika-archer", name: "Эрика-лучница", price: 200 },
];

/** Полный каталог из 78 Mixamo-персонажей.
 * ?v=3 — cache-busting. История:
 *   v=2 (2026-07-09) — на S1 временно пропали glb/png, браузеры
 *        закэшировали HTML-фолбэк под этими URL с max-age=30d immutable.
 *   v=3 (2026-07-31) — v=2 не помог: первые GET-ы пришли РАНЬШЕ, чем
 *        ассеты восстановили, и прогрели HTML-фолбэк уже под новым URL.
 *        Симптом: «Unexpected token '<'» на skin_*.glb?v=2, битые png
 *        в меню, THREE.WebGLRenderer: Context Lost и тёмный экран.
 * Файлы на проде проверены (78/78 glb + 78/78 png отдают бинарь),
 * так что v=3 гарантированно прогреется корректным содержимым. */
const ASSETS_V = "?v=3";
const CATALOG = _entries.map((e) => ({
  folder: e.folder,
  name: e.name,
  price: e.price,
  avatar: `/character-assets/skins/${e.folder}.png${ASSETS_V}`,
  glb: `/character-assets/skins/${e.folder}.glb${ASSETS_V}`,
}));

// Сортируем: дефолтные (бесплатные) первыми, остальные по имени
CATALOG.sort((a, b) => {
  if (a.price === 0 && b.price !== 0) return -1;
  if (b.price === 0 && a.price !== 0) return 1;
  if (a.folder === DEFAULT_FREE_SKIN && b.folder !== DEFAULT_FREE_SKIN) return -1;
  if (b.folder === DEFAULT_FREE_SKIN && a.folder !== DEFAULT_FREE_SKIN) return 1;
  return a.name.localeCompare(b.name, "ru");
});

/**
 * Возвращает список скинов: [{folder, name, price, avatar, glb}].
 */
export async function getSkinsCatalog(_signal) {
  return CATALOG;
}

/** Найти скин по folder. */
export function skinByFolder(catalog, folder) {
  return catalog.find((s) => s.folder === folder) || null;
}

/** Множество всех валидных folder-id (быстрая O(1) проверка). */
const VALID_FOLDERS = new Set(CATALOG.map((s) => s.folder));

/** Проверка: существует ли скин в актуальном каталоге.
 *  Используется для очистки legacy-значений из БД и localStorage
 *  (skin_bacon-hair, skin_sigma-labubu и др. — устарели с 2026-06-11). */
export function isValidSkin(folder) {
  return typeof folder === "string" && VALID_FOLDERS.has(folder);
}

/** Цена скина (для AvatarScreen). 0 = бесплатно. */
export function priceForSkin(folder) {
  const e = CATALOG.find((s) => s.folder === folder);
  return e ? e.price : SKIN_PRICE;
}
